export async function exchangeProxyCode(code, proxyBaseUrl) {
  const response = await fetch(`${proxyBaseUrl}/new-auth/on-demand/token`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ code }),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || 'Failed to exchange auth code');
  }
  return data;
}
